<i class="pi pi-spin pi-spinner" *ngIf="show && !isLarge"></i>
<i class="pi pi-spin pi-spinner" *ngIf="show && isLarge" style="font-size: 5em"></i>
